export const SERVICE_NAV = [
  {
    "title": "Layanan",
    "link": "#",
    "childItems": [
      {
        "title": "Tentang Lifepal",
        "link": "/tentang/",
      },
      {
        "title": "Bantuan",
        "link": "/pusat-bantuan/",
      },
      {
        "title": "Ketentuan",
        "link": "/ketentuan/",
      },
      {
        "title": "Cara Pembelian",
        "link": "/cara-beli/",
      }
    ],
  }
];